import {
  FaUserPlus,
  FaChalkboardTeacher,
  FaTools,
  FaCertificate,
} from "react-icons/fa";
import { motion } from "framer-motion";

const steps = [
  {
    icon: <FaUserPlus />,
    title: "Apply",
    desc: "Fill out the registration form to begin your journey.",
  },
  {
    icon: <FaChalkboardTeacher />,
    title: "Orientation",
    desc: "Attend an orientation session with our mentors.",
  },
  {
    icon: <FaTools />,
    title: "Project Training",
    desc: "Work on real-world projects under expert guidance.",
  },
  {
    icon: <FaCertificate />,
    title: "Certification",
    desc: "Receive an industry-recognized internship certificate.",
  },
];

// Animation settings
const animationProps = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

const InternshipTimeline = () => {
  return (
    <section className="bg-gray-50 py-16 px-4 mb-4">
      <h2 className="text-3xl font-bold text-center text-sky-700 mb-12">
        Internship Process
      </h2>

      <div className="relative max-w-6xl mx-auto">
        {/* Horizontal Line */}
        <div className="absolute top-8 left-0 right-0 hidden md:block h-1 bg-sky-300 z-0"></div>

        {/* Steps */}
        <div className="flex flex-col md:flex-row items-center justify-between relative z-10">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex flex-col items-center text-center w-full md:w-1/4 px-4 mb-12 md:mb-0"
              {...animationProps}
            >
              <div className="w-16 h-16 rounded-full bg-sky-600 text-white flex items-center justify-center text-2xl mb-4 shadow-lg z-10">
                {step.icon}
              </div>
              <h3 className="text-lg font-semibold text-sky-700 mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-gray-600">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InternshipTimeline;
